import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const styles: any = makeStyles(() =>
    createStyles({
        root: {},
        toolbar: {},
        spacing: {
            minHeight: '5.3rem',
            width: '100%',
        },
        appBar: {},
        toolBar: {},
    }),
);

export default styles;
